import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NetzTranslationLoader } from '../services/netz-translation-loader';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../services/environment.service';

export const translateModule = TranslateModule.forChild({
  loader: {
    provide: TranslateLoader,
    useClass: NetzTranslationLoader,
    deps: [HttpClient, EnvironmentService],
  },
});
